export default {
	tableHeaders: {
		database: {
			name: 'Назва',
			shortName: 'Коротка назва',
			alias: 'Аліас',
			baseType: 'Тип бази',
			comment: 'Коментар',
			server: 'Сервер'
		},
		app: {
			name: 'Назва',
			alias: 'Аліас',
			apiType: 'Тип програми',
			path: 'Шлях',
			server: 'Сервер',
			isWebApp: 'web?',
			yes: "так",
			no: "ні"
		},
		server: {
			name: 'Назва',
			serverType: 'Тип сервера',
			httpPath: 'Шлях http',
			host: 'Хост',
			path: 'Шлях',
			isTiny: 'Tiny'
		},
		user: {
			login: 'Логін',
			password: 'Пароль',
			fullName: 'ПІБ',
			datePassword: 'Дата пароля',
			dateEnd: 'Дата створення',
			dateBegin: 'Дата закінчення',
			role: 'Роль',
			status: 'Статус',
			statusDisabled: 'відключений',
			statusEnabled: 'включений'
		},
		role: {
			id: 'ID',
			name: 'Назва',
			type: 'Тип ролі'
		},
		appParam: {
			id: 'ID',
			name: 'Назва'
		},
		upgrades: {
			idVersion: "ID версії",
			datecurr: "Дата встановлення"
		},
		process: {
			app: 'Програма',
			db: 'База даних',
			lstart: 'Старт завдання',
			etime: 'Час роботи',
			pcpu: 'Завантаження CPU,%',
			ip: 'IP адреса',
			user: 'Користувач'
		},
		service: {
			s: 'Сервіс',
			p: 'Параметр',
			st: 'Статус',
			dst: 'Доп. статус '
		},
		statusTask: {
			id: '№',
			pidTask: 'pid',
			nameTask: 'Завдання',
			paramsTask: 'Параметри',
			nameServer: 'Сервер',
			qDateBegin: 'Запущена',
			qDateEnd: 'Завершена',
			nameUser: 'Ким',
			comment: 'Примітка'
		},
		task: {
			id: 'ID',
			caption: 'Назва',
			path: 'Шлях',
			isPacketable: 'В пакеті',
			idTypeTask: 'Тип завдання',
			comment: 'Коментар'
		}
	}
};
